import React from 'react';
import { Changapassword, Changepasswordprops } from './Changepassword.types';
import { changePasswordReducer, initialState } from './Changepassword.reducer';

export const Changepasswordcontext = React.createContext<Changapassword>({
  username: '',
  resetPasswordToken: '',
  clearContext: () => {},
  updateContext: () => {},
});

const Changepasswordprovider = ({ children }: Changepasswordprops) => {
  const [{ username, resetPasswordToken }, dispatch] = React.useReducer(changePasswordReducer, initialState);

  const updateContext = React.useCallback((username: string, resetPasswordToken: string) => {
    dispatch({ type: 'UPDATE_CONTEXT', payload: { username, resetPasswordToken } });
  }, []);

  const clearContext = React.useCallback(() => {
    dispatch({ type: 'CLEAR_CONTEXT' });
  }, []);

  return (
    <Changepasswordcontext.Provider value={{ username, resetPasswordToken, updateContext, clearContext }}>
      {children}
    </Changepasswordcontext.Provider>
  );
};

export default Changepasswordprovider;
